var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"vipAnalyze",staticClass:"vipAnalyze",on:{"scroll":function($event){return _vm.screenFiexd()}}},[_c('div',[_c('screen',{class:_vm.isFiexd ? 'fiexdScreen' : ''}),_c('vipOverview'),_c('vipElevator'),_c('vipTendency'),_c('vipProportion'),_c('vipContribute'),_c('vipComparison')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }